import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomAlertComponent } from 'src/app/shared/components/custom-alert/custom-alert.component';
import { ErrorInfo } from '../models/errorIntercept/errorModel';
import { TOAST_DURATION } from 'src/app/shared/constants/toast-duration';

@Injectable({
	providedIn: 'root'
})
export class AlertService {
	datosError: ErrorInfo;

	constructor(
		public snackBar: MatSnackBar,
		private zone: NgZone
	) {}

	public open(
		message: string,
		action: string,
		icon?: string,
		duration?: number
	) {
		// Sin 4.º arg → TOAST_DURATION. Con 4.º arg undefined → sin auto-dismiss.
		const resolvedDuration =
			arguments.length >= 4 ? duration : TOAST_DURATION;

		this.zone.run(() => {
			this.snackBar.openFromComponent(CustomAlertComponent, {
				data: { message: message, action: action, icon: icon },
				duration: resolvedDuration
			});
		});
	}
}
